const pino= require('pino')
const logger = pino({
    safe:true,
    level:'info',
    timestamp:true,
    prettyPrint:true,
});
export default logger;